import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=57cac2d0&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=ts"
export * from "./_slug.vue?vue&type=script&lang=ts"
import style0 from "./_slug.vue?vue&type=style&index=0&id=57cac2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cac2d0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextPressure: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/text-pressure.vue').default,AuroraBackground: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/aurora-background.vue').default,CBtn: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/content/c-btn.vue').default,ProjectMemberNew: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/project-member-new.vue').default,PageShareNew: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-share-new.vue').default,ListControlNew: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/list-control-new.vue').default,PageBottom: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-bottom/index.vue').default})
